var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChromeExtension(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50305 3.907C5.87626 2.67638 7.65611 1.99713 9.50005 2C10.8653 1.99968 12.2048 2.37204 13.374 3.07693C14.5433 3.78182 15.4979 4.7925 16.1351 6H9.50005C8.80974 5.99975 8.13478 6.20364 7.56005 6.58602C6.98533 6.9684 6.53651 7.51219 6.27005 8.149L4.50305 3.907Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74502 4.69C2.95996 5.6296 2.41677 6.74706 2.16286 7.94485C1.90895 9.14264 1.95203 10.3844 2.28835 11.5617C2.62467 12.739 3.244 13.8161 4.0923 14.699C4.94061 15.582 5.9921 16.2439 7.15502 16.627L9.96702 12.969C9.81369 12.9897 9.65802 13 9.50002 13C8.70787 13.0002 7.93908 12.7317 7.31931 12.2384C6.69955 11.745 6.26546 11.056 6.08802 10.284C6.06818 10.2552 6.05142 10.2243 6.03802 10.192L3.74502 4.69Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21497 16.89C8.63297 16.9633 9.0613 17 9.49997 17C10.7005 17.0004 11.8836 16.7127 12.9498 16.1609C14.016 15.6091 14.9342 14.8094 15.6271 13.8291C16.3201 12.8487 16.7676 11.7163 16.932 10.5271C17.0964 9.3379 16.9729 8.12659 16.572 6.995L16.5 7H11.95C12.2825 7.32592 12.5466 7.71491 12.7269 8.14419C12.9072 8.57347 13 9.0344 13 9.5C13.0011 10.394 12.6601 11.2545 12.047 11.905L8.21497 16.89Z",
    fill: "#667085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.5C7 8.83696 7.26339 8.20107 7.73223 7.73223C8.20107 7.26339 8.83696 7 9.5 7C10.163 7 10.7989 7.26339 11.2678 7.73223C11.7366 8.20107 12 8.83696 12 9.5C12 10.163 11.7366 10.7989 11.2678 11.2678C10.7989 11.7366 10.163 12 9.5 12C8.83696 12 8.20107 11.7366 7.73223 11.2678C7.26339 10.7989 7 10.163 7 9.5Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeExtension);
export default __webpack_public_path__ + "static/media/chrome-extension.649b86760f4612983cfcb53408cb9f05.svg";
export { ForwardRef as ReactComponent };